import { useState, useEffect, useRef, MutableRefObject } from 'react';

import { IUseState } from '../../../shared/types/IUseState';

export type IActiveExperienceWinner = {
    image: {
        src: string;
        alt: string;
    }
    copy: string;
};

type VoidFunc = () => void;

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
function useInterval (callback: VoidFunc, delay: number | null): void {
    const savedCallback: MutableRefObject<undefined | VoidFunc> = useRef();

    // Remember the latest callback.
    useEffect((): void => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect((): VoidFunc | void => {
        function tick (): void {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }

        if (delay !== null) {
            const id: number = window.setInterval(tick, delay);

            return (): void => {
                return window.clearInterval(id);
            };
        }
    }, [delay]);
}

export function useActiveExperienceWinners (): IActiveExperienceWinner[] | null {
    const [winners, setWinners]: IUseState<IActiveExperienceWinner[] | null> = useState<IActiveExperienceWinner[] | null>(null);
    const [ticks, setTicks]: IUseState<number> = useState(0);
    const [delay, setDelay]: IUseState<number | null> = useState<number | null>(10);
    const requestTimeout: number = 5000; // in milliseconds
    let timeElapsed: number = 0;

    if (typeof delay === 'number') {
        timeElapsed = ticks * delay;
    }

    useInterval((): void => {
        if (timeElapsed > requestTimeout) {
            setWinners(null);
            setDelay(null);
            return;
        }

        setTicks(ticks + 1);

        if (window.ozActiveExperienceApp.winners) {
            setWinners(window.ozActiveExperienceApp.winners);
            setDelay(null);
        }
    },  delay);

    return winners;
}
